import checkIsTicketGroupShownInQuery from './checkIsTicketGroupShownInQuery';

export default function checkIsTicketGroupVisible(ticketGroup = {}, query = {}) {
  if (ticketGroup.hidden) {
    const isTicketGroupShownInQuery = checkIsTicketGroupShownInQuery(ticketGroup.reference, query);

    if (isTicketGroupShownInQuery) return true;

    return false;
  }

  return true;
}
